import { __decorate, __extends } from "tslib";
import { Injectable } from '@angular/core';
import { AwesomeCordovaNativePlugin, cordova } from '@awesome-cordova-plugins/core';
import * as i0 from "@angular/core";
var AdjustConfig = /** @class */function () {
  function AdjustConfig(appToken, environment) {
    this.logLevel = null;
    this.defaultTracker = null;
    this.externalDeviceId = null;
    this.isSendingInBackgroundEnabled = null;
    this.isDeferredDeeplinkOpeningEnabled = null;
    this.isCostDataInAttributionEnabled = null;
    this.isCoppaComplianceEnabled = null;
    this.isDeviceIdsReadingOnceEnabled = null;
    this.eventDeduplicationIdsMaxSize = null;
    this.urlStrategyDomains = [];
    this.useSubdomains = null;
    this.isDataResidency = null;
    // android only
    this.processName = null;
    this.isPreinstallTrackingEnabled = null;
    this.preinstallFilePath = null;
    this.isPlayStoreKidsComplianceEnabled = null;
    this.fbAppId = null;
    // ios only
    this.isAdServicesEnabled = null;
    this.isIdfaReadingEnabled = null;
    this.isIdfvReadingEnabled = null;
    this.isSkanAttributionEnabled = null;
    this.isLinkMeEnabled = null;
    this.attConsentWaitingInterval = null;
    // callbacks
    this.attributionCallback = null;
    this.eventTrackingSucceededCallback = null;
    this.eventTrackingFailedCallback = null;
    this.sessionTrackingSucceededCallback = null;
    this.sessionTrackingFailedCallback = null;
    this.deferredDeeplinkCallback = null;
    this.skanUpdatedCallback = null;
    this.appToken = appToken;
    this.environment = environment;
  }
  AdjustConfig.prototype.setLogLevel = function (logLevel) {
    this.logLevel = logLevel;
  };
  AdjustConfig.prototype.setDefaultTracker = function (defaultTracker) {
    this.defaultTracker = defaultTracker;
  };
  AdjustConfig.prototype.setExternalDeviceId = function (externalDeviceId) {
    this.externalDeviceId = externalDeviceId;
  };
  AdjustConfig.prototype.setUrlStrategy = function (urlStrategyDomains, useSubdomains, isDataResidency) {
    this.urlStrategy = urlStrategy;
  };
  AdjustConfig.prototype.enableSendingInBackground = function () {
    this.isSendingInBackgroundEnabled = true;
  };
  AdjustConfig.prototype.disableDeferredDeeplinkOpening = function () {
    this.isDeferredDeeplinkOpeningEnabled = false;
  };
  AdjustConfig.prototype.enableCoppaCompliance = function () {
    this.isCoppaComplianceEnabled = true;
  };
  AdjustConfig.prototype.enableDeviceIdsReadingOnce = function () {
    this.isDeviceIdsReadingOnceEnabled = true;
  };
  AdjustConfig.prototype.enablePlayStoreKidsCompliance = function () {
    this.isPlayStoreKidsComplianceEnabled = true;
  };
  AdjustConfig.prototype.enableCostDataInAttribution = function () {
    this.isCostDataInAttributionEnabled = true;
  };
  AdjustConfig.prototype.setProcessName = function (processName) {
    this.processName = processName;
  };
  AdjustConfig.prototype.enablePreinstallTracking = function () {
    this.isPreinstallTrackingEnabled = true;
  };
  AdjustConfig.prototype.setPreinstallFilePath = function (preinstallFilePath) {
    this.preinstallFilePath = preinstallFilePath;
  };
  AdjustConfig.prototype.setFbAppId = function (fbAppId) {
    this.fbAppId = fbAppId;
  };
  AdjustConfig.prototype.disableIdfaReading = function () {
    this.isIdfaReadingEnabled = false;
  };
  AdjustConfig.prototype.disableIdfvReading = function () {
    this.isIdfvReadingEnabled = false;
  };
  AdjustConfig.prototype.disableAdServices = function () {
    this.isAdServicesEnabled = false;
  };
  AdjustConfig.prototype.enableLinkMe = function () {
    this.isLinkMeEnabled = true;
  };
  AdjustConfig.prototype.disableSkanAttribution = function () {
    this.isSkanAttributionEnabled = false;
  };
  AdjustConfig.prototype.setAttConsentWaitingInterval = function (attConsentWaitingInterval) {
    this.attConsentWaitingInterval = attConsentWaitingInterval;
  };
  AdjustConfig.prototype.setAttributionCallback = function (attributionCallback) {
    this.attributionCallback = attributionCallback;
  };
  AdjustConfig.prototype.setEventTrackingSucceededCallback = function (eventTrackingSucceededCallback) {
    this.eventTrackingSucceededCallback = eventTrackingSucceededCallback;
  };
  AdjustConfig.prototype.setEventTrackingFailedCallback = function (eventTrackingFailedCallback) {
    this.eventTrackingFailedCallback = eventTrackingFailedCallback;
  };
  AdjustConfig.prototype.setSessionTrackingSucceededCallback = function (sessionTrackingSucceededCallback) {
    this.sessionTrackingSucceededCallback = sessionTrackingSucceededCallback;
  };
  AdjustConfig.prototype.setSessionTrackingFailedCallback = function (sessionTrackingFailedCallback) {
    this.sessionTrackingFailedCallback = sessionTrackingFailedCallback;
  };
  AdjustConfig.prototype.setDeferredDeeplinkCallback = function (deferredDeeplinkCallback) {
    this.deferredDeeplinkCallback = deferredDeeplinkCallback;
  };
  AdjustConfig.prototype.setSkanUpdatedCallback = function (skanUpdatedCallback) {
    this.skanUpdatedCallback = skanUpdatedCallback;
  };
  AdjustConfig.prototype.getAttributionCallback = function () {
    return this.attributionCallback;
  };
  AdjustConfig.prototype.getEventTrackingSucceededCallback = function () {
    return this.eventTrackingSucceededCallback;
  };
  AdjustConfig.prototype.getEventTrackingFailedCallback = function () {
    return this.eventTrackingFailedCallback;
  };
  AdjustConfig.prototype.getSessionTrackingSucceededCallback = function () {
    return this.sessionTrackingSucceededCallback;
  };
  AdjustConfig.prototype.getSessionTrackingFailedCallback = function () {
    return this.sessionTrackingFailedCallback;
  };
  AdjustConfig.prototype.getDeferredDeeplinkCallback = function () {
    return this.deferredDeeplinkCallback;
  };
  AdjustConfig.prototype.getSkanUpdatedCallback = function () {
    return this.skanUpdatedCallback;
  };
  AdjustConfig.prototype.hasAttributionCallback = function () {
    return this.attributionCallback !== null;
  };
  AdjustConfig.prototype.hasEventTrackingSucceededCallback = function () {
    return this.eventTrackingSucceededCallback !== null;
  };
  AdjustConfig.prototype.hasEventTrackingFailedCallback = function () {
    return this.eventTrackingFailedCallback !== null;
  };
  AdjustConfig.prototype.hasSessionTrackingSucceededCallback = function () {
    return this.sessionTrackingSucceededCallback !== null;
  };
  AdjustConfig.prototype.hasSessionTrackingFailedCallback = function () {
    return this.sessionTrackingFailedCallback !== null;
  };
  AdjustConfig.prototype.hasDeferredDeeplinkCallback = function () {
    return this.deferredDeeplinkCallback !== null;
  };
  AdjustConfig.prototype.hasSkanUpdatedCallback = function () {
    return this.skanUpdatedCallback !== null;
  };
  return AdjustConfig;
}();
export { AdjustConfig };
var AdjustEvent = /** @class */function () {
  function AdjustEvent(eventToken) {
    this.callbackParameters = [];
    this.partnerParameters = [];
    this.eventToken = eventToken;
  }
  AdjustEvent.prototype.setRevenue = function (revenue, currency) {
    this.revenue = revenue;
    this.currency = currency;
  };
  AdjustEvent.prototype.addCallbackParameter = function (key, value) {
    this.callbackParameters.push(key);
    this.callbackParameters.push(value);
  };
  AdjustEvent.prototype.addPartnerParameter = function (key, value) {
    this.partnerParameters.push(key);
    this.partnerParameters.push(value);
  };
  AdjustEvent.prototype.setTransactionId = function (transactionId) {
    this.transactionId = transactionId;
  };
  AdjustEvent.prototype.setDeduplicationId = function (deduplicationId) {
    this.deduplicationId = deduplicationId;
  };
  AdjustEvent.prototype.setCallbackId = function (callbackId) {
    this.callbackId = callbackId;
  };
  AdjustEvent.prototype.setProductId = function (productId) {
    this.productId = productId;
  };
  AdjustEvent.prototype.setPurchaseToken = function (purchaseToken) {
    this.purchaseToken = purchaseToken;
  };
  return AdjustEvent;
}();
export { AdjustEvent };
var AdjustAppStoreSubscription = /** @class */function () {
  function AdjustAppStoreSubscription(price, currency, transactionId) {
    this.callbackParameters = [];
    this.partnerParameters = [];
    this.price = price;
    this.currency = currency;
    this.transactionId = transactionId;
  }
  AdjustAppStoreSubscription.prototype.setTransactionDate = function (transactionDate) {
    this.transactionDate = transactionDate;
  };
  AdjustAppStoreSubscription.prototype.setSalesRegion = function (salesRegion) {
    this.salesRegion = salesRegion;
  };
  AdjustAppStoreSubscription.prototype.addCallbackParameter = function (key, value) {
    this.callbackParameters.push(key);
    this.callbackParameters.push(value);
  };
  AdjustAppStoreSubscription.prototype.addPartnerParameter = function (key, value) {
    this.partnerParameters.push(key);
    this.partnerParameters.push(value);
  };
  return AdjustAppStoreSubscription;
}();
export { AdjustAppStoreSubscription };
var AdjustPlayStoreSubscription = /** @class */function () {
  function AdjustPlayStoreSubscription(price, currency, sku, orderId, signature, purchaseToken) {
    this.callbackParameters = [];
    this.partnerParameters = [];
    this.price = price;
    this.currency = currency;
    this.sku = sku;
    this.orderId = orderId;
    this.signature = signature;
    this.purchaseToken = purchaseToken;
  }
  AdjustPlayStoreSubscription.prototype.setPurchaseTime = function (purchaseTime) {
    this.purchaseTime = purchaseTime;
  };
  AdjustPlayStoreSubscription.prototype.addCallbackParameter = function (key, value) {
    this.callbackParameters.push(key);
    this.callbackParameters.push(value);
  };
  AdjustPlayStoreSubscription.prototype.addPartnerParameter = function (key, value) {
    this.partnerParameters.push(key);
    this.partnerParameters.push(value);
  };
  return AdjustPlayStoreSubscription;
}();
export { AdjustPlayStoreSubscription };
var AdjustThirdPartySharing = /** @class */function () {
  function AdjustThirdPartySharing(isEnabled) {
    this.granularOptions = [];
    this.partnerSharingSettings = [];
    this.isEnabled = isEnabled;
  }
  AdjustThirdPartySharing.prototype.addGranularOption = function (partnerName, key, value) {
    this.granularOptions.push(partnerName);
    this.granularOptions.push(key);
    this.granularOptions.push(value);
  };
  AdjustThirdPartySharing.prototype.addPartnerSharingSetting = function (partnerName, key, value) {
    this.partnerSharingSettings.push(partnerName);
    this.partnerSharingSettings.push(key);
    this.partnerSharingSettings.push(value);
  };
  return AdjustThirdPartySharing;
}();
export { AdjustThirdPartySharing };
var AdjustAdRevenue = /** @class */function () {
  function AdjustAdRevenue(source) {
    this.callbackParameters = [];
    this.partnerParameters = [];
    this.source = source;
  }
  AdjustAdRevenue.prototype.setRevenue = function (revenue, currency) {
    this.revenue = revenue;
    this.currency = currency;
  };
  AdjustAdRevenue.prototype.addCallbackParameter = function (key, value) {
    this.callbackParameters.push(key);
    this.callbackParameters.push(value);
  };
  AdjustAdRevenue.prototype.addPartnerParameter = function (key, value) {
    this.partnerParameters.push(key);
    this.partnerParameters.push(value);
  };
  AdjustAdRevenue.prototype.setAdImpressionsCount = function (adImpressionsCount) {
    this.adImpressionsCount = adImpressionsCount;
  };
  AdjustAdRevenue.prototype.setAdRevenueNetwork = function (adRevenueNetwork) {
    this.adRevenueNetwork = adRevenueNetwork;
  };
  AdjustAdRevenue.prototype.setAdRevenueUnit = function (adRevenueUnit) {
    this.adRevenueUnit = adRevenueUnit;
  };
  AdjustAdRevenue.prototype.setAdRevenuePlacement = function (adRevenuePlacement) {
    this.adRevenuePlacement = adRevenuePlacement;
  };
  return AdjustAdRevenue;
}();
export { AdjustAdRevenue };
var AdjustAppStorePurchase = /** @class */function () {
  function AdjustAppStorePurchase(productId, transactionId) {
    this.productId = productId;
    this.transactionId = transactionId;
  }
  return AdjustAppStorePurchase;
}();
export { AdjustAppStorePurchase };
var AdjustPlayStorePurchase = /** @class */function () {
  function AdjustPlayStorePurchase(productId, purchaseToken) {
    this.productId = productId;
    this.purchaseToken = purchaseToken;
  }
  return AdjustPlayStorePurchase;
}();
export { AdjustPlayStorePurchase };
var AdjustDeeplink = /** @class */function () {
  function AdjustDeeplink(deeplink) {
    this.deeplink = deeplink;
  }
  return AdjustDeeplink;
}();
export { AdjustDeeplink };
export var AdjustEnvironment = /*#__PURE__*/function (AdjustEnvironment) {
  AdjustEnvironment["Sandbox"] = "sandbox";
  AdjustEnvironment["Production"] = "production";
  return AdjustEnvironment;
}(AdjustEnvironment || {});
export var AdjustLogLevel = /*#__PURE__*/function (AdjustLogLevel) {
  AdjustLogLevel["Verbose"] = "VERBOSE";
  AdjustLogLevel["Debug"] = "DEBUG";
  AdjustLogLevel["Info"] = "INFO";
  AdjustLogLevel["Warn"] = "WARN";
  AdjustLogLevel["Error"] = "ERROR";
  AdjustLogLevel["Assert"] = "ASSERT";
  AdjustLogLevel["Suppress"] = "SUPPRESS";
  return AdjustLogLevel;
}(AdjustLogLevel || {});
var Adjust = /** @class */function (_super) {
  __extends(Adjust, _super);
  function Adjust() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Adjust.prototype.initSdk = function (adjustConfig) {
    return cordova(this, "initSdk", {
      "sync": true
    }, arguments);
  };
  Adjust.prototype.trackEvent = function (adjustEvent) {
    return cordova(this, "trackEvent", {
      "sync": true
    }, arguments);
  };
  Adjust.prototype.trackAppStoreSubscription = function (adjustAppStoreSubscription) {
    return cordova(this, "trackAppStoreSubscription", {
      "sync": true
    }, arguments);
  };
  Adjust.prototype.trackPlayStoreSubscription = function (adjustPlayStoreSubscription) {
    return cordova(this, "trackPlayStoreSubscription", {
      "sync": true
    }, arguments);
  };
  Adjust.prototype.trackThirdPartySharing = function (adjustThirdPartySharing) {
    return cordova(this, "trackThirdPartySharing", {
      "sync": true
    }, arguments);
  };
  Adjust.prototype.trackAdRevenue = function (adjustAdRevenue) {
    return cordova(this, "trackAdRevenue", {
      "sync": true
    }, arguments);
  };
  Adjust.prototype.trackMeasurementConsent = function (measurementConsent) {
    return cordova(this, "trackMeasurementConsent", {
      "sync": true
    }, arguments);
  };
  Adjust.prototype.switchToOfflineMode = function () {
    return cordova(this, "switchToOfflineMode", {
      "sync": true
    }, arguments);
  };
  Adjust.prototype.switchBackToOnlineMode = function () {
    return cordova(this, "switchBackToOnlineMode", {
      "sync": true
    }, arguments);
  };
  Adjust.prototype.processDeeplink = function (adjustDeeplink) {
    return cordova(this, "processDeeplink", {
      "sync": true
    }, arguments);
  };
  Adjust.prototype.processAndResolveDeeplink = function (adjustDeeplink) {
    return cordova(this, "processAndResolveDeeplink", {}, arguments);
  };
  Adjust.prototype.enable = function () {
    return cordova(this, "enable", {
      "sync": true
    }, arguments);
  };
  Adjust.prototype.disable = function () {
    return cordova(this, "disable", {
      "sync": true
    }, arguments);
  };
  Adjust.prototype.setPushToken = function (pushToken) {
    return cordova(this, "setPushToken", {
      "sync": true
    }, arguments);
  };
  Adjust.prototype.isEnabled = function () {
    return cordova(this, "isEnabled", {}, arguments);
  };
  Adjust.prototype.gdprForgetMe = function () {
    return cordova(this, "gdprForgetMe", {
      "sync": true
    }, arguments);
  };
  Adjust.prototype.getGoogleAdId = function () {
    return cordova(this, "getGoogleAdId", {}, arguments);
  };
  Adjust.prototype.getAmazonAdId = function () {
    return cordova(this, "getAmazonAdId", {}, arguments);
  };
  Adjust.prototype.getIdfa = function () {
    return cordova(this, "getIdfa", {}, arguments);
  };
  Adjust.prototype.getIdfv = function () {
    return cordova(this, "getIdfv", {}, arguments);
  };
  Adjust.prototype.getAdid = function () {
    return cordova(this, "getAdid", {}, arguments);
  };
  Adjust.prototype.getAttribution = function () {
    return cordova(this, "getAttribution", {}, arguments);
  };
  Adjust.prototype.getSdkVersion = function () {
    return cordova(this, "getSdkVersion", {}, arguments);
  };
  Adjust.prototype.addGlobalCallbackParameter = function (key, value) {
    return cordova(this, "addGlobalCallbackParameter", {
      "sync": true
    }, arguments);
  };
  Adjust.prototype.removeGlobalCallbackParameter = function (key) {
    return cordova(this, "removeGlobalCallbackParameter", {
      "sync": true
    }, arguments);
  };
  Adjust.prototype.removeGlobalCallbackParameters = function () {
    return cordova(this, "removeGlobalCallbackParameters", {
      "sync": true
    }, arguments);
  };
  Adjust.prototype.addGlobalPartnerParameter = function (key, value) {
    return cordova(this, "addGlobalPartnerParameter", {
      "sync": true
    }, arguments);
  };
  Adjust.prototype.removeGlobalPartnerParameter = function (key) {
    return cordova(this, "removeGlobalPartnerParameter", {
      "sync": true
    }, arguments);
  };
  Adjust.prototype.removeGlobalPartnerParameters = function () {
    return cordova(this, "removeGlobalPartnerParameters", {
      "sync": true
    }, arguments);
  };
  Adjust.prototype.requestAppTrackingAuthorization = function () {
    return cordova(this, "requestAppTrackingAuthorization", {}, arguments);
  };
  Adjust.prototype.updateSkanConversionValue = function (conversionValue, coarseValue, lockWindow) {
    return cordova(this, "updateSkanConversionValue", {}, arguments);
  };
  Adjust.prototype.getAppTrackingAuthorizationStatus = function () {
    return cordova(this, "getAppTrackingAuthorizationStatus", {}, arguments);
  };
  Adjust.prototype.getLastDeeplink = function () {
    return cordova(this, "getLastDeeplink", {}, arguments);
  };
  Adjust.prototype.verifyAppStorePurchase = function (adjustAppStorePurchase) {
    return cordova(this, "verifyAppStorePurchase", {}, arguments);
  };
  Adjust.prototype.verifyPlayStorePurchase = function (adjustPlayStorePurchase) {
    return cordova(this, "verifyPlayStorePurchase", {}, arguments);
  };
  Adjust.ɵfac = /* @__PURE__ */(() => {
    let ɵAdjust_BaseFactory;
    return function Adjust_Factory(__ngFactoryType__) {
      return (ɵAdjust_BaseFactory || (ɵAdjust_BaseFactory = i0.ɵɵgetInheritedFactory(Adjust)))(__ngFactoryType__ || Adjust);
    };
  })();
  Adjust.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: Adjust,
    factory: Adjust.ɵfac
  });
  Adjust.pluginName = "Adjust";
  Adjust.plugin = "com.adjust.sdk";
  Adjust.pluginRef = "Adjust";
  Adjust.repo = "https://github.com/adjust/cordova_sdk";
  Adjust.platforms = ["Android", "iOS"];
  Adjust = __decorate([], Adjust);
  return Adjust;
}(AwesomeCordovaNativePlugin);
export { Adjust };
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
